<div class="container-fluid bgwhite" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%; background-color:#f1f1f3;">
    <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row ">
            <!--Left + Menu + Old-->
            <div style="display: inline-block; display: none">
                <ul class="menu notStore animationIf webView bgwhite" id="RespMenu"
                    style=" box-shadow: 1px 1px 4px 0px rgba(0,0,0,0.1)" ng-show="!isStorePage">
                    <li style="cursor: pointer;">
                        <a href="https://www.biziverse.com" target="_blank">
                            <div class="" style="padding: 15px 0px;">
                                <img src="assets/images/logo2.jpg" style="width: 100px;" alt="Biziverse" />
                            </div>
                        </a>
                    </li>
                    <li style="text-align: center;">
                        <div style="padding: 10px 0px 15px;">
                            <span (click)="actionMenu(0);" class="btn  lableBtnDarkBlue menubottomBtn"
                                style="border:1px solid #4caf500d; border-radius: 50%; vertical-align: middle;  margin: 0px 1px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtGreenMain "
                                    style="background: #4caf5033 !important;color:#4caf50 ; padding: 3px 8px !important; border-radius: 50%; font-size: 13px;"
                                    title="Dashboard">
                                    <i class="fa fa-home" style="display: inline-block;color:#4caf50 !important"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border: 1px solid #e8842108;border-radius: 50%; vertical-align: middle;  margin: 0px 4px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtnOrange"
                                    style="padding: 3px 8px !important; border-radius: 50%; background: #e8842133 !important;font-size: 13px; color: #e88421 !important"
                                    title="Appointments" (click)="actionMenu(8);"
                                    *ngIf="!agencyData.isAssociation && isShowInMenu.isAppShow">
                                    <i class="fa fa-calendar" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border: 1px solid #1f628e0a;border-radius: 50%; vertical-align: middle; margin: 0px 1px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">

                                <span class="btn lableBtnDarkBlue menubottomBtn"
                                    style="padding: 3px 8px !important; border-radius: 50%; vertical-align: middle; font-size: 13px; margin: 0px 0px; background: #1f628e33 !important; color: #1f628e "
                                    title="Refresh" (click)="RefreshPage()">
                                    <i class="fa fa-refresh" style="display: inline-block;color:#1f628e !important"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border:1px solid rgb(218 165 32 / 0.1) ;border-radius: 50%; vertical-align: middle; margin: 0px 4px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtnDarkBlue menubottomBtn"
                                    style="padding: 3px 8px !important; background: #DAA52033 !important; color: #DAA520 !important; border-radius: 50%; vertical-align: middle; font-size: 13px; margin: 0px 0px;"
                                    title="Settings" (click)="actionMenu(13);" *ngIf="settingRgt.isShowSetting">
                                    <i class="fa fa-cog" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border:1px solid #1f628e0a;border-radius: 50%; vertical-align: middle;  margin: 0px 1px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtnRed "
                                    style="padding: 3px 8px; background: #00808033 !important; color: #008080; border-radius: 50%; vertical-align: middle; font-size: 13px; margin: 0px 0px;"
                                    title="Logout" (click)="logOut();">
                                    <i class="fa fa-power-off" style="display: inline-block;"></i>
                                </span>
                            </span>
                        </div>
                    </li>

                    <!-- Main Icon -->
                    <li style="min-height: 65px; background: #fff">
                        <div style="min-height: 65px; background: rgb(254 192 7 / 5%);">
                            <div style="border-top: 1px solid #ddd; padding-left: 5%; padding-right: 5%"
                                (click)="showSubNetwork()">
                                <h3 style="color: #DAA520; font-size: 18px; margin-top: 12px; margin-bottom: 6px;">
                                    <span style="font-weight: bold">Network</span>
                                    <!-- <span class="chevron">
                      <i class="zmdi {{subNetwork ?  '' : 'zmdi-chevron-down'}} "></i>
                    </span> -->
                                </h3>
                                <!-- <h6 style="color: #DAA520; line-height: 1.5; margin-bottom: 0px; padding-bottom: 10px;">
                    <span>{{subNetwork ? 'Expand Reach' : 'Widen your Reach, Build your Brand'}}</span>
                  </h6> -->
                            </div>
                            <div style="padding-bottom: 10px">
                                <div class="subLi crmhvr" (click)="actionMenu(7);">
                                    <span style="color: #DAA520; margin-right: 8px"><i
                                            class="fa fa-globe"></i></span><span>Connections</span>
                                </div>
                                <div class="subLi crmhvr" (click)="actionMenu(9);">
                                    <span style="color: #DAA520; margin-right: 8px"><i
                                            class="fa fa-rss"></i></span><span>Newsfeed</span>
                                </div>
                                <div class="subLi crmhvr" (click)="actionMenu(6);">
                                    <span style="color: #DAA520; margin-right: 8px"><i
                                            class="zmdi zmdi-city-alt"></i></span><span>Your
                                        Store</span>
                                </div>
                                <div class="subLi crmhvr" (click)="actionMenu(13);" *ngIf="settingRgt.isShowSetting">
                                    <span style="color: #DAA520; margin-right: 8px"><i
                                            class="zmdi zmdi-accounts-alt"></i></span><span>Team</span>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li style="min-height: 65px; background: #fff ">
                        <div style="min-height: 65px; background: #4caf500d;">
                            <div style="border-top: 1px solid #ddd; padding-left: 5%; padding-right: 5%"
                                (click)="showSubSource()">
                                <h3 style="color: #4caf50; font-size: 18px; margin-top: 12px; margin-bottom: 6px;">
                                    <span style="font-weight: bold">Sourcing</span>
                                    <!-- <span class="chevron">
                      <i class="zmdi {{subSourcing ?  '' : 'zmdi-chevron-down'}}"></i>
                    </span> -->
                                </h3>
                                <!-- <h6 style="color: #4caf50; line-height: 1.5">
                    <span>{{subSourcing ? 'Buy Right' : 'Buy from the Best Suppliers'}}</span>
                  </h6> -->
                            </div>
                            <div style="padding-bottom: 10px">
                                <!-- *ngIf="subSourcing" -->
                                <!-- <div class="subLi sourcing" style="padding: 3px 6% !important" (click)="actionMenu(20);">
                                <span style="color: #4caf50; margin-right: 8px"><i
                                    class="zmdi zmdi-store"></i></span><span>Vendors</span>
                                    </div> -->
                                <div class="subLi sourcing" (click)="actionMenu(11);">
                                    <span style="color: #4caf50; margin-right: 8px"><i
                                            class="fa fa-search"></i></span><span>Search</span>
                                </div>
                                <div class="subLi sourcing" (click)="actionMenu(15);"
                                    *ngIf="isShowInMenu.isPurchaseShow">
                                    <span style="color: #4caf50; margin-right: 8px"><i
                                            class="fa fa-shopping-cart"></i></span><span>Orders</span>
                                </div>
                                <div class="subLi sourcing" (click)="actionMenu(15);">
                                    <span style="color: #4caf50; margin-right: 8px"><i
                                            class="fa fa-comments "></i></span><span>RFQs</span>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li style="min-height: 65px; background: #fff">
                        <div style="min-height: 65px; background: #e8842108;">
                            <div style="border-top: 1px solid #ddd; padding-left: 5%; padding-right: 5%"
                                (click)="showSubCRM()">
                                <h3 style="color: #e88421; font-size: 18px; margin-top: 12px; margin-bottom: 6px;">
                                    <span style="font-weight: bold">Sales</span>
                                    <!-- <span class="chevron">
                      <i class="zmdi {{subCRM ?  '' : 'zmdi-chevron-down'}}"></i>
                    </span> -->
                                </h3>
                                <!-- <h6 style="color: #e88421; line-height: 1.5"><span>
                      {{subCRM ? 'Delight Customers' : 'Delight Customers, Expand Bussiness'}} </span></h6> -->
                            </div>
                            <div style="padding-bottom: 10px">
                                <!-- *ngIf="subCRM"-->
                                <div class="subLi erpHvr" (click)="actionMenu(21)">
                                    <span style="color: #e88421; margin-right: 8px"><i
                                            class="zmdi zmdi-account-add"></i></span><span>Prospects</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(2);" *ngIf="isShowInMenu.isInquiryShow">
                                    <span style="color: #e88421; margin-right: 8px"><i
                                            class="fa fa-comments"></i></span><span>Inquiries</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(16);">
                                    <span style="color: #e88421; margin-right: 8px"><i
                                            class="fa fa-share"></i></span><span>Quotes</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(1);" *ngIf="isShowInMenu.isOrdersShow">
                                    <span style="color: #e88421; margin-right: 8px"><i
                                            class="fa fa-shopping-cart"></i></span><span>Orders</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(24)">
                                    <span style="color: #e88421; margin-right: 8px;"><i
                                            class="fa fa-money"></i></span><span>Invoices</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(5);">
                                    <span style="color: #e88421; margin-right: 8px; margin-left: 4px"><i
                                            class="fa fa-inr"></i></span><span>Recovery</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(18)">
                                    <span style="color: #e88421; margin-right: 8px"><i
                                            class="zmdi zmdi-file-text"></i></span><span>Contracts</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(32)">
                                    <span style="color:#e88421; margin-right:8px;"><i 
                                            class="fa fa-question"></i></span><span>Support Requests</span>
                                </div>
                                <div class="subLi erpHvr" (click)="actionMenu(17)" *ngIf="isShowSupport">
                                    <span style="color: #e88421; margin-right: 8px;"><i
                                            class="fa fa-headphones"></i></span><span>Support</span>
                                </div>

                            </div>
                        </div>

                    </li>

                    <li style="min-height: 65px; background:#fff; display: none;">
                        <div style="min-height: 65px; background: #1f628e0a; border-bottom: 1px solid #ddd;">
                            <div style="border-top: 1px solid #ddd; padding-left: 5%; padding-right: 5%"
                                (click)="showSubERP()">
                                <h3 style="color: #1f628e; font-size: 18px; margin-top: 12px; margin-bottom: 6px;">
                                    <span style="font-weight: bold">ERP</span>
                                    <span class="chevron">
                                        <i class="zmdi {{subERP ? '' : 'zmdi-chevron-down'}}"></i>
                                    </span>
                                </h3>
                                <h6 style="color: #1f628e; line-height: 1.5"><span>
                                        {{subERP ? 'Manage Smartly' : 'Systematize Operations, Simplify Management'}}</span></h6>
                            </div>
                            <div style="padding-bottom: 10px; transition: 2s" *ngIf="subERP">
                                <div class="subLi networkHvr" routerLink="/accounts">
                                    <span style="color: #1f628e; margin-right: 8px"><i
                                            class="fa fa-inr"></i></span><span>Accounts</span>
                                </div>
                                <div class="subLi networkHvr" (click)="comingSoon()">
                                    <span style="color: #1f628e; margin-right: 8px"><i
                                            class="zmdi zmdi-widgets"></i></span><span>Inventory</span>
                                </div>
                                <!-- <div class="subLi networkHvr" style="padding: 3px 6% !important" (click)="comingSoon()">
                  <span style="color: #1f628e; margin-right: 8px"><i class="fa fa-users"></i></span><span>Payroll</span>
                </div> -->
                                <div class="subLi networkHvr" (click)="comingSoon()">
                                    <span style="color: #1f628e; margin-right: 8px"><i
                                            class="zmdi zmdi-view-dashboard"></i></span><span
                                        style="margin-left: 5px">Projects</span>
                                </div>
                                <div class="subLi networkHvr" (click)="comingSoon()">
                                    <span style="color: #1f628e; margin-right: 8px"><i
                                            class="fa fa-check"></i></span><span>Tasks</span>
                                </div>
                                <div class="subLi networkHvr" (click)="comingSoon()">
                                    <span style="color: #1f628e; margin-right: 8px"><i
                                            class="fa fa-pie-chart"></i></span><span>KPIs</span>
                                </div>

                            </div>
                        </div>
                    </li>

                    <!-- <li style="min-height: 90px; background: #fff">
            <div style="min-height: 90px; background: #e8842108;">
              <div style="border-top: 1px solid #ddd; padding-left: 5%; padding-right: 5%" (click)="showSubCRM()">
                <h3 style="color: #e88421; font-size: 18px; margin-top: 12px; margin-bottom: 6px;">
                  <span style="font-weight: bold">Employee</span> -->
                    <!-- <span class="chevron">
                      <i class="zmdi {{subCRM ?  '' : 'zmdi-chevron-down'}}"></i>
                    </span> -->
                    <!-- </h3> -->
                    <!-- <h6 style="color: #e88421; line-height: 1.5"><span>
                      {{subCRM ? 'Delight Customers' : 'Delight Customers, Expand Bussiness'}} </span></h6> -->
                    <!-- </div> -->
                    <!-- <div style="padding-bottom: 10px">
              
                <div class="subLi erpHvr" style="padding: 3px 6% !important" (click)="actionMenu(21)">
                  <span style="color: #e88421; margin-right: 8px"><i
                      class="zmdi zmdi-account-add"></i></span><span>Attendance</span>
                </div>
                 <div class="subLi erpHvr" style="padding: 3px 6% !important" (click)="actionMenu(2);"
                  *ngIf="isShowInMenu.isInquiryShow">
                  <span style="color: #e88421; margin-right: 8px"><i
                      class="fa fa-comments"></i></span><span>Payroll</span>
                </div> -->

                    <!-- <div class="subLi erpHvr" style="padding: 3px 6% !important" (click)="actionMenu(2);"
                  *ngIf="isShowInMenu.isInquiryShow">
                  <span style="color: #e88421; margin-right: 8px"><i
                      class="fa fa-cog"></i></span><span>Setting</span>
                </div> -->
                    <!-- </div> -->
                    <!-- </div> -->

                    <!-- </li> -->
                </ul>
            </div>

            <!-- new main menu Web View -->
            <div class="webView" *ngIf="isIndianAgency && (isVoucher || isStockEntry || isDefaultGrp) && bzvzEdition != 4 && !isClosSettingShow" >
                <ul class="menu notStore animationIf  menuBgColor"  id="RespMenu"
                    style="box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.1);padding: 0px 0px;" *ngIf="!isStorePage">
                    <li style="cursor: pointer; background-color: white;">
                        <a href="https://www.biziverse.com" target="_blank" style="">
                            <div class="" [ngStyle]="isQikERP ? {'padding': '5px 0px'} : {'padding': '15px 0px'}">
                                <img [src]="isQikERP ? 'assets/images/QikERP.png' : 'assets/images/logo2.jpg'" style="width: 100px;" alt="Biziverse" />
                            </div>
                        </a>
                    </li>

                    <li style="padding: 8px 10px 0px;">
                        <div style="">
                            <span class=""style="vertical-align: middle; margin: 0px 0px; padding: 0px !important">
                                <span class="btn menubottomBtn " title="Dashboard"
                                    (click)="actionMenu(0);">
                                    <i class="fa fa-home font14" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class=""
                                style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px;  padding: 0px !important">
                                <span class="btn menubottomBtn" style="border-radius: 50%; padding: 0px 5px!important;" title="Need help?"
                                    (click)="openHelp();">
                                    <i class="fa fa-question font14" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class=""
                                style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                                <span class="btn menubottomBtn " style="border-radius: 50%; font-size: 12px !important; " title="Refresh"
                                    (click)="RefreshPage();">
                                    <i class="fa fa-refresh" style="display: inline-block"></i>
                                </span>
                            </span>
                            <!-- Change Pin -->
                            <span *ngIf="!settingRgt.isShowSetting" class=""
                                style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important;">
                                <span class="btn menubottomBtn " style="border-radius: 50% " title="Change Password"  (click) ="changePassword();">
                                    <i class="fa fa-key" style="display: inline-block; font-size: 11px;"></i>
                                </span>
                            </span>
                            <span class=""
                                style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                                <span class="btn menubottomBtn " style="border-radius: 50% " title="Settings"
                                    (click)="actionMenu(13);" *ngIf="settingRgt.isShowSetting">
                                    <i class="zmdi zmdi-settings" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class=""
                                style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                                <span class="btn menubottomBtn " style="border-radius: 50% " title="Logout"
                                    (click)="logOut();">
                                    <i class="fa fa-power-off" style="display: inline-block;"></i>
                                </span>
                            </span>
                        </div>
                    </li>

                    <!-- <li style="text-align:center;">
                        <div style="padding: 10px 0px 15px;">
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border:1px solid #4caf500d;border-radius: 50%; vertical-align: middle; margin: 0px 0px; margin-right: 3px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtGreenMain "
                                    style="background: #4caf5033 !important;color:#4caf50 ; padding: 3px 7px; border-radius: 50%;font-size: 13px;"
                                    title="Dashboard" (click)="actionMenu(0);">
                                    <i class="fa fa-home" style="display: inline-block;color:#4caf50 !important"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border: 1px solid #e8842108;border-radius: 50%; vertical-align: middle;  margin: 0px 0px; margin-right: 3px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtnOrange"
                                    style="padding: 3px 7px; border-radius: 50%; background: #e8842133 !important;font-size: 13px; color: #e88421 !important"
                                    title="Appointments" (click)="actionMenu(8);"
                                    *ngIf="!agencyData.isAssociation && isShowInMenu.isAppShow">
                                    <i class="fa fa-calendar" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border: 1px solid #1f628e0a;border-radius: 50%; vertical-align: middle;  margin: 0px 0px; margin-right: 3px;  background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtGreenMain "
                                    style="padding: 3px 7px; border-radius: 50%; vertical-align: middle; font-size: 13px; margin: 0px 0px; background: #1f628e33 !important; color: #1f628e "
                                    title="Refresh" (click)="refresh();">
                                    <i class="fa fa-refresh" style="display: inline-block;color:#1f628e !important"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border:1px solid rgb(218 165 32 / 0.1) ;border-radius: 50%; vertical-align: middle;  margin: 0px 0px; margin-right: 3px; background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtnDarkBlue "
                                    style="padding: 3px 7px; background: #DAA52033 !important; color: #DAA520 !important; border-radius: 50%; vertical-align: middle; font-size: 13px; margin: 0px 0px;"
                                    title="Settings" (click)="actionMenu(13);" *ngIf="settingRgt.isShowSetting">
                                    <i class="fa fa-cog" style="display: inline-block;"></i>
                                </span>
                            </span>
                            <span class="btn lableBtnDarkBlue menubottomBtn"
                                style="border:1px solid #1f628e0a;border-radius: 50%; vertical-align: middle;  margin: 0px 0px; margin-right: 3px;  background:#FFF !important; color:#4caf50 !important; padding: 0px !important">
                                <span class="btn lableBtnRed "
                                    style="padding: 3px 7px; background: #00808033 !important; color: #008080; border-radius: 50%; vertical-align: middle; font-size: 13px; margin: 0px 0px;"
                                    title="Logout" (click)="logOut();">
                                    <i class="fa fa-power-off" style="display: inline-block;"></i>
                                </span>
                            </span>
                        </div>
                    </li> -->


                    <!-- Main Icon -->
                    <li  class="menuBgColor" style="min-height:65px; ;text-align: left;">
                        <div style="min-height: 65px;" class="">
                            <div style="padding-left:8%; padding-right:8%" (click)="showSubCRM()">
                                <h3 style="color:#e88421;font-size:15px; margin-top:7px ">
                                    <span style="font-weight:bold">Sales</span>
                                    <!-- <span class="chevron">
                                        <i class="zmdi {{subCRM ?  '' : 'zmdi-chevron-down'}}"></i>
                                    </span> -->
                                </h3>
                                <!-- <h6 style="color:#e88421; line-height:1.5"><span>Delight Customers</span></h6> -->
                                <!--'Delight Customers, Expand Bussiness'-->
                            </div>
                            <div *ngIf="!isNewDsb" style="padding-bottom:10px;padding: 0px 0px 5px 3px;">
                                <!-- *ngIf="selectedMenu.val == 1" -->
                                <!--ng-if="subCRM"-->
                                <!-- CRM-->
                                <a href="{{isPremiumAgency ? '../../../main.html#' + leadsPath : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                    *ngIf="crmRights.propViewTypeID != 0 || crmRights.propEntry || crmRights.propEdit" (click)="actionMenu(29)">
                                    <div class="subLi crmhvr">
                                        <span style="margin-right:8px"><i
                                                class="zmdi zmdi-accounts"></i></span>
                                                <span>CRM <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Prospects display: none-->
                                <a *ngIf="isMgrnDone" href="{{isPremiumAgency ? '../../../main.html#/Kanban' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none; display: none;" (click)="actionMenu(21)">
                                    <div class="subLi crmhvr"
                                        *ngIf="crmRights.propViewTypeID != 0 || crmRights.propEntry || crmRights.propEdit">
                                        <span style="margin-right:8px"><i
                                                class="zmdi zmdi-account-add"></i></span>
                                                <span>Prospects <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Inquiries -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/Inquiry' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(2);">
                                    <div class="subLi crmhvr " 
                                        *ngIf="isShowInMenu.isInquiryShow">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-comments"></i></span>
                                                <span>Inquiries <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Quotes -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/Docs?M=7' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(22);">
                                    <div class="subLi crmhvr "
                                        *ngIf="crmRights.quoteEntry || crmRights.quoteEdit">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-share"></i></span>
                                                <span>Quotes <i *ngIf="!isPremiumAgency" class="fa fa-lock" style=" font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Orders -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/orders' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                    *ngIf="crmRights.ordViewTypeID == 1 || crmRights.ordeEntry || crmRights.ordChange || crmRights.ordStatusChng" (click)="actionMenu(1);">
                                    <div class="subLi crmhvr " >
                                        <span style="margin-right:8px"><i
                                                class="fa fa-shopping-cart"></i></span><span>Orders<i *ngIf="!isPremiumAgency" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px; margin-left: 3px;"></i></span>
                                    </div>
                                </a>

                                <!-- Invoices -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/Invoices' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(24)"
                                *ngIf="crmRights.invEntry || crmRights.invEdit || crmRights.invoiceView">
                                    <div class="subLi crmhvr">
                                        <span style="margin-right:8px; "><i
                                                class="fa fa-money"></i></span>
                                                <span>Invoices <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Recovery -->
                                <a href="../../../main.html#/Network?st=R" style="text-decoration:none">
                                    <div class="subLi crmhvr " (click)="actionMenu(5);" *ngIf="crmRights.invRecovery">
                                        <span style="margin-right:8px; margin-left:4px"><i
                                                class="fa fa-inr"></i></span><span>Recovery</span>
                                    </div>
                                </a>

                                <!-- Contracts -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/Contracts' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(18)">
                                    <div class="subLi crmhvr "
                                        *ngIf="crmRights.contEntry || crmRights.contUpdate|| crmRights.contChange">
                                        <span style="margin-right:8px"><i
                                                class="zmdi zmdi-file-text"></i></span>
                                                <span>Contracts <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i></span>
                                    </div>
                                </a>
                                
                                <!--Supports Req-->
                                <a href="../../../main.html#/Inquiry?typ=s" style="text-decoration:none">
                                    <div class="subLi crmhvr"  (click)="actionMenu(32)" 
                                    *ngIf="(crmRights.propViewTypeID != 0 || crmRights.custViewTypeID != 0 || b2bRights.conn) && AgencyID == 1">
                                         <span style="margin-right:8px;"><i 
                                            class="fa fa-question"></i></span><span>Tickets</span>
                                    </div>
                                </a>

                                <!-- Support -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/orders?ID=sup' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(31)">
                                    <div class="subLi crmhvr "
                                        *ngIf="crmRights.ordViewTypeID == 1 || crmRights.ordeEntry || crmRights.ordChange || crmRights.ordStatusChng">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-headphones"></i></span>
                                                <span>Support <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Customers -->
                                <a href="{{isPremiumAgency ? '../../../main.html#/Network?st=c&ut=2' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(40)">
                                    <div class="subLi crmhvr" *ngIf="(crmRights.custViewTypeID != 0 || crmRights.custEntry || crmRights.custEdit)">
                                        <span style="margin-right:8px"><i class="fa fa-globe"></i></span>
                                        <span>Customers <i *ngIf="!isPremiumAgency" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i></span>
                                    </div>
                                </a>
                            </div>

                            <div *ngIf="isNewDsb" style="padding-bottom: 10px; padding: 0px 0px 5px 3px;">
                                <!-- CRM-->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#' + leadsPath : '../../../main.html#/home?p=1'}}" 
                                        style="text-decoration: none !important; width: 100%;" 
                                        *ngIf="crmRights.propViewTypeID != 0 || crmRights.propEntry || crmRights.propEdit">
                                        <div (click)="actionMenu(29)">
                                            <div class="menuIcon"><i class="zmdi zmdi-accounts"></i></div><span class="menuPadLeft">CRM</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.propEntry" class="quickAddBtn" (click)="redirectToEntry(1)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Prospects display: none-->
                                <div *ngIf="isMgrnDone"  style="display: flex; justify-content: space-between; display: none;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/Kanban' : '../../../main.html#/home?p=1'}}" 
                                        style="text-decoration: none !important; width: 100%;" 
                                        *ngIf="crmRights.propViewTypeID != 0 || crmRights.propEntry || crmRights.propEdit">
                                        <div (click)="actionMenu(21)">
                                            <div class="menuIcon"><i class="zmdi zmdi-account-add"></i></div><span class="menuPadLeft">Prospects</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.propEntry" class="quickAddBtn" (click)="redirectToEntry(2)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Inquiries -->
                                <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../ main.html#/Inquiry' : '../../../main.html#/home?p=1'}}" style="text-decoration: none; display: block; padding: 0 !important;">
                                    <div class="subLi" (click)="actionMenu(17);" *ngIf="isShowInMenu.isInquiryShow">
                                        <div class="menuIcon"><i class="fa fa-comments"></i></div><span class="menuPadLeft">Inquiries</span>
                                    </div>
                                </a>
                                <!-- Quotes -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/Docs?M=7' : '../../../main.html#/home?p=1'}}" 
                                        style="text-decoration: none; width: 100%;" *ngIf="crmRights.quoteEntry || crmRights.quoteEdit">
                                        <div (click)="askIfFirstDoc(22, 'list');">
                                            <div class="menuIcon"><i class="fa fa-share"></i></div><span class="menuPadLeft">Quotes</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.quoteEntry" class="quickAddBtn" (click)="askIfFirstDoc(3, 'entry')">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Orders -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/orders' : '../../../main.html#/home?p=1'}}" 
                                        style="text-decoration:none; width: 100%;" *ngIf="crmRights.ordViewTypeID != 0 || crmRights.ordeEntry || crmRights.ordChange || crmRights.ordStatusChng">
                                        <div (click)="askIfFirstDoc(1, 'list');">
                                            <div class="menuIcon"><i class="fa fa-shopping-cart"></i></div><span class="menuPadLeft">Orders</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.ordeEntry" class="quickAddBtn" (click)="askIfFirstDoc(4, 'entry')">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Invoices -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/Invoices' :  '../../../main.html#/home?p=1'}}" 
                                        style="text-decoration:none; width: 100%;" *ngIf="crmRights.invEntry || crmRights.invEdit || crmRights.invoiceView">
                                        <div (click)="askIfFirstDoc(24, 'list')">
                                            <div class="menuIcon"><i class="fa fa-money"></i></div><span class="menuPadLeft" >Invoices</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.invEntry" class="quickAddBtn" (click)="askIfFirstDoc(5, 'entry')">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Recovery -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/Network?st=R' :  '../../../main.html#/home?p=1'}}" 
                                        style="text-decoration:none; width: 100%;" *ngIf="crmRights.invRecovery">
                                        <div (click)="actionMenu(5);">
                                            <div class="menuIcon" style="margin-left: 4px"><i class="fa fa-inr"></i></div><span class="menuPadLeft">Recovery</span>
                                        </div>
                                    </a>
                                </div>
                                 <!-- Contracts -->
                                 <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/Contracts' : '../../../main.html#/home?p=1'}}" style="text-decoration:none; width: 100%;" 
                                        *ngIf="crmRights.contEntry || crmRights.contUpdate|| crmRights.contChange">
                                        <div (click)="actionMenu(18)">
                                            <div class="menuIcon"><i class="zmdi zmdi-file-text"></i></div><span class="menuPadLeft">Contracts</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.contEntry" class="quickAddBtn" (click)="redirectToEntry(7)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Tickets -->
                                <a class="subLi noHvr" href="{{isPremiumAgencyPaid ? 'main.html#/Inquiry?typ=s' : '../../../main.html#/home?p=1'}}" style="text-decoration:none; display: block; padding: 0 !important;">
                                    <div class="subLi" (click)="actionMenu(32)" *ngIf="(crmRights.propViewTypeID != 0 || crmRights.custViewTypeID != 0 || b2bRights.conn) && AgencyID == 1">
                                        <div class="menuIcon"><i class="fa fa-question"></i></div><span class="menuPadLeft">Tickets</span>
                                    </div>
                                </a>
                                <!-- Support -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a style="text-decoration: none; width: 100%;"  class="subLi noHvr" href="{{isPremiumAgencyPaid ? '../../../main.html#/orders?ID=sup' : '../../../main.html#/home?p=1'}}" 
                                        *ngIf="(crmRights.ordViewTypeID != 0 || crmRights.ordeEntry || crmRights.ordChange || crmRights.ordStatusChng)">
                                        <div (click)="actionMenu(31)">
                                            <div class="menuIcon"><i class="fa fa-headphones"></i></div><span class="menuPadLeft">Support</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.ordeEntry" class="quickAddBtn" (click)="redirectToEntry(8)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Customer -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" style="text-decoration:none; width: 100%;" href="{{isPremiumAgencyPaid ? '../../../main.html#/Network?st=c&ut=2' : '../../../main.html#/home?p=1'}}" 
                                        *ngIf="(crmRights.custViewTypeID != 0 || crmRights.custEntry || crmRights.custEdit)">
                                        <div (click)="actionMenu(40)"> 
                                            <div class="menuIcon"><i class="fa fa-globe"></i></div><span class="menuPadLeft">Customers</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.custEntry" class="quickAddBtn" (click)="redirectToEntry(9)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </li>

                    <!-- ERP -->
                    <!-- *ngIf="bzvzEdition == 3 || ((agnERPRight.EnblAccounts || agnERPRight.EnblInventory || agnERPRight.EnblProduction) && erpRights.showERP)" -->
                    <li class="menuBgColor" style="min-height: 65px; text-align: left;" *ngIf="((agnERPRight.EnblAccounts || agnERPRight.EnblInventory || agnERPRight.EnblProduction) && erpRights.showERP)"> <!-- *ngIf="erpRights.showERP" -->
                        <div class="" style="min-height:65px;">
                            <div style="padding-left:8%; padding-right:8%" (click)="showSubERP()">
                                <h3 style="color:#e88421;font-size:15px ;margin-top:12px">
                                    <span style="font-weight:bold">Operations</span>
                                    <!-- <span class="chevron">
                                        <i class="zmdi {{subERP ?  '' : 'zmdi-chevron-down'}}"></i>
                                    </span> -->
                                </h3>
                                <!-- <h6 style="color:#1f628e; line-height:1.5"><span>Manage Smartly</span></h6> -->
                            </div>
                            <div *ngIf="!isNewDsb" style="padding-bottom:10px; transition:2s">
                                <!-- *ngIf="selectedMenu.val == 3" -->
                                <a href="{{isPremiumAgencyPaid ? 'accounts' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                   *ngIf="(isPremiumAgencyPaid && agnERPRight.EnblAccounts && (erpRights.acctRpt || erpRights.vchrEntry || erpRights.acctConfig))"
                                    (click)="actionMenu(26)">
                                    <div class="subLi crmhvr " >
                                        <span style="margin-right:8px"><i
                                                class="fa fa-inr"></i></span>
                                                <span> 
                                                    Accounts <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                                </span>
                                    </div>
                                </a>
                                <!-- Purchases (Supplier Invoices) -->
                                <a href="{{isPremiumAgencyPaid ? '../../../main.html#/Docs?M=6' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                   *ngIf="(isPremiumAgencyPaid && (erpRights.splrInvViewTypeID || erpRights.splrInvEntry || erpRights.splrInvEdit))"
                                    (click)="actionMenu(37)">
                                    <div class="subLi crmhvr">
                                        <span style="margin-right:8px"><i class="fa fa-money"></i></span>
                                        <span> 
                                            Purchases 
                                            <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                        </span>
                                    </div>
                                </a>
                                <!-- Purch Order -->
                                <a href="{{isPremiumAgencyPaid ? '../../../main.html#/Docs?M=8' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                   *ngIf="(isPremiumAgencyPaid && agnERPRight.EnblAccounts && erpRights.purOrder)"
                                    (click)="actionMenu(38)">
                                    <div class="subLi crmhvr">
                                        <span style="margin-right:8px"><i class="fa fa-shopping-cart"></i></span>
                                        <span> 
                                            Purch Orders 
                                            <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                        </span>
                                    </div>
                                </a>

                                <a href="{{isPremiumAgencyPaid ? 'Stock' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                   *ngIf="(isPremiumAgencyPaid && agnERPRight.EnblInventory && (erpRights.invStatus || erpRights.invTran || erpRights.invEntry || erpRights.invRpt || erpRights.invCfg))" (click)="actionMenu(27)">
                                    <div class="subLi crmhvr ">
                                        <span style="margin-right:8px">
                                            <i class="zmdi zmdi-widgets"></i>
                                        </span>
                                        <span>
                                            Inventory <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                        </span>
                                    </div>
                                </a>
                                <a href="#" style="text-decoration:none;display:none">
                                    <div class="subLi crmhvr " (click)="comingSoon()">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-users"></i></span><span>Payroll</span>
                                    </div>
                                </a>

                                <a href="{{isPremiumAgencyPaid ? 'ProductionList?p=1' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                    *ngIf="(isPremiumAgencyPaid && agnERPRight.EnblProduction && (erpRights.mfgMovement || erpRights.mfgRpt || erpRights.mfgCfg))" (click)="actionMenu(28)">
                                    <div class="subLi crmhvr ">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-industry"></i></span>
                                        <span>
                                            Manufacturing <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                        </span>
                                    </div>
                                </a>
                                <a href="{{isPremiumAgencyPaid ? 'Projects?p=2' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                                    *ngIf="(isPremiumAgencyPaid && agnERPRight.EnblProjects && (erpRights.mfgMovement || erpRights.mfgRpt || erpRights.mfgCfg))" (click)="actionMenu(36)">
                                    <div class="subLi crmhvr ">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-align-left"></i></span>
                                        <span>
                                            Projects <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                        </span> 
                                    </div>
                                </a>
                                <a href="../../../main.html#/Purchase" style="text-decoration:none;display:none"
                                    (click)="actionMenu(15);" *ngIf="erpRights.purOrder || erpRights.purVendorInq">
                                    <div class="subLi crmhvr" (click)="actionMenu(15);"
                                        *ngIf="isShowInMenu.isPurchaseShow">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-shopping-cart"></i></span><span>Purchase</span>
                                    </div>
                                </a>
                                <a href="{{isPremiumAgencyPaid ? 'Tasks' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none;"
                                *ngIf="(isPremiumAgencyPaid && agnERPRight.ETS)" (click)="actionMenu(34);">
                                    <div class="subLi crmhvr" (click)="actionMenu(34);"
                                        *ngIf="isShowInMenu.isPurchaseShow">
                                        <span style="margin-right:8px">
                                            <i class="fa fa-tasks"></i></span><span>Tasks <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i></span>
                                    </div>
                                </a>

                                <!-- Supplier -->
                                <a href="{{isPremiumAgencyPaid ? '../../../main.html#/Network?st=c&ut=4' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none;"
                                *ngIf="isPremiumAgencyPaid && (crmRights.SplrViewTypeID != 0 || erpRights.supEntry || erpRights.supChange)" (click)="actionMenu(39);">
                                    <div class="subLi crmhvr" (click)="actionMenu(39);">
                                        <span style="margin-right:8px"><i class="fa fa-globe"></i></span>
                                        <span>
                                            Suppliers 
                                            <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                        </span>
                                    </div>
                                </a>
                            </div>

                            <div *ngIf="isNewDsb" style="padding-bottom:10px; transition:2s">
                                <!-- Accounts -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr"> 
                                    <a class="subLi noHvr" style="text-decoration:none;width: 100%;" (click)="actionMenu(26)" href="{{isPremiumAgencyPaid ? 'accounts' : '../../../main.html#/home?p=1'}}"
                                    *ngIf="isPremiumAgencyPaid && (erpRights.acctRpt || erpRights.vchrEntry || erpRights.acctConfig) && agnERPRight.EnblAccounts">
                                        <div>
                                            <div  class="menuIcon"><i class="fa fa-inr"></i></div><span style="padding-left: 3px;">Accounts</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="erpRights.vchrEntry" class="quickAddBtn" (click)="redirectToEntry(10)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Purchases (Supplier Invoices) -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" style="text-decoration:none; width: 100%;" (click)="askIfFirstDoc(37, 'list')" href="{{isPremiumAgencyPaid ? '../../../main.html#/Docs?M=6' : '../../../main.html#/home?p=1'}}"
                                    *ngIf="(isPremiumAgencyPaid && (erpRights.splrInvViewTypeID || erpRights.splrInvEntry || erpRights.splrInvEdit))">
                                        <div>
                                            <div  class="menuIcon"><i class="fa fa-money"></i></div><span style="padding-left: 3px;">Purchases</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="crmRights.invEntry" class="quickAddBtn" (click)="askIfFirstDoc(11, 'entry')">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Purchase Orders -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr " style="text-decoration:none;width: 100%;" (click)="askIfFirstDoc(38, 'list')" href="{{isPremiumAgencyPaid ? '../../../main.html#/Docs?M=8' : '../../../main.html#/home?p=1'}}"
                                    *ngIf="isPremiumAgencyPaid && (erpRights.purOrder || erpRights.poEdit || erpRights.poView)">
                                        <div>
                                            <div  class="menuIcon"><i class="fa fa-shopping-cart"></i></div><span style="padding-left: 3px;">Purch Orders</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="erpRights.purOrder" class="quickAddBtn" (click)="askIfFirstDoc(12, 'entry')">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Inventory -->
                                <div ng-show="(isPremiumAgencyPaid && agnERPRight.EnblInventory && (erpRights.invStatus || erpRights.invTran || erpRights.invEntry || erpRights.invRpt || erpRights.invCfg))" style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" style="text-decoration:none;width: 100%;" (click)="actionMenu(27)" href="{{isPremiumAgencyPaid ? 'Stock' : '../../../main.html#/home?p=1'}}">
                                        <div>
                                            <div  class="menuIcon"><i class="zmdi zmdi-widgets"></i></div><span class="menuPadLeft">Inventory</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-smile-o" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="erpRights.invEntry" class="quickAddBtn" (click)="redirectToEntry(13)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Manufacturing -->
                                <div ng-show="(isPremiumAgencyPaid && agnERPRight.EnblProduction && (erpRights.mfgMovement || erpRights.mfgRpt || erpRights.mfgCfg))" style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" style="text-decoration:none; width: 100%;" (click)="actionMenu(28)" href="{{isPremiumAgencyPaid ? 'ProductionList?p=1' : '../../../main.html#/home?p=1'}}">
                                        <div>
                                            <div  class="menuIcon" style="margin-right: 4px;"><i class="fa fa-industry"></i></div><span class="menuPadLeft">Manufacturing</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span class="quickAddBtn" (click)="redirectToEntry(14)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Projects -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr" *ngIf="(isPremiumAgencyPaid && agnERPRight.EnblProjects && (erpRights.mfgMovement || erpRights.mfgRpt || erpRights.mfgCfg))">
                                    <a class="subLi noHvr" style="text-decoration:none; width: 100%;" (click)="actionMenu(36)" href="{{isPremiumAgencyPaid ? 'Projects?p=2' : '../../../main.html#/home?p=1'}}">
                                        <div>
                                            <div  class="menuIcon"><i class="fa fa-align-left"></i></div><span class="menuPadLeft">Projects</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span class="quickAddBtn" (click)="actionMenu(36)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Tasks -->
                                <div style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="subLi noHvr" style="text-decoration: none;width: 100%;" (click)="actionMenu(34);" href="{{isPremiumAgencyPaid ? 'Tasks' : '../../../main.html#/home?p=1'}}"
                                    *ngIf="(isPremiumAgencyPaid && agnERPRight.ETS)">
                                        <div>
                                            <div class="menuIcon"><i class="fa fa-tasks" aria-hidden="true"></i></div><span class="menuPadLeft">Tasks</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span class="quickAddBtn" (click)="redirectToEntry(19)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                                <!-- Supplier -->
                                <div ng-show="isPremiumAgencyPaid && (crmRights.SplrViewTypeID != 0 || erpRights.supEntry || erpRights.supChange)" style="display: flex; justify-content: space-between;" class="erpHvr">
                                    <a class="noHvr subLi" style="text-decoration: none;width: 100%;" (click)="actionMenu(39)"
                                        href="{{isPremiumAgencyPaid ? '../../../main.html#/ConnectionEntry?t=s' : '../../../main.html#/home?p=1'}}">
                                        <div>
                                            <div class="menuIcon"><i class="fa fa-globe" aria-hidden="true"></i></div><span class="menuPadLeft">Suppliers</span>
                                            <span style="vertical-align: middle;">
                                                <i *ngIf="!isPremiumAgencyPaid" class="fa fa-lock" style="color: #B0B0B0; font-size: 13px;"></i>
                                            </span>
                                        </div>
                                    </a>
                                    <span ng-show="erpRights.supEntry" class="quickAddBtn" (click)="redirectToEntry(17)">
                                        <i class="zmdi zmdi-plus"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="menuBgColor" style="min-height:65px;text-align: left;"
                        *ngIf="crmRights.ConnViewTypeID != 0 || crmRights.SplrViewTypeID != 0 || b2bRights.webStore || b2bRights.newsFeeds || crmRights.custViewTypeID != 0 || crmRights.propViewTypeID != 0">
                        <div style="min-height:65px;">
                            <!--{{subNetwork ? 'rgb(254 192 7 / 5%)' : 'rgb(254 192 7 / 5%)' }}-->
                            <div style="padding-left:8%; padding-right:8%" (click)="showSubNetwork()">
                                <h3 style="font-size:15px ; margin-top:12px">
                                    <span class="orangeText" style="font-weight:bold">Network</span>
                                    <!-- <span class="chevron">
                                        <i class="zmdi {{subNetwork ?  '' : 'zmdi-chevron-down'}} "></i>
                                    </span> -->
                                </h3>
                                <!-- <h6 class="greenText" style="line-height:1.5;margin-bottom:0px; padding-bottom:10px;">
                                    <span>Expand Reach</span>
                                </h6> -->
                            </div>
                            <div style="padding-bottom:10px">
                                <!-- *ngIf="selectedMenu.val == 2" -->
                                <!--ng-if="subNetwork"-->
                                <a href="../../../main.html#/Network?st=c" style="text-decoration:none">
                                    <div class="subLi crmhvr  " (click)="actionMenu(7);" *ngIf="crmRights.ConnViewTypeID != 0 || crmRights.SplrViewTypeID != 0 || crmRights.custViewTypeID != 0 || crmRights.propViewTypeID != 0">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-globe"></i></span><span>Connections</span>
                                    </div>
                                </a>
                                <a href="../../../main.html#/Feed" style="text-decoration:none;display:none">
                                    <div class="subLi crmhvr  " (click)="actionMenu(9);"
                                        *ngIf="b2bRights.newsFeeds">
                                        <span  style="margin-right:8px"><i
                                                class="fa fa-rss"></i></span><span>Newsfeed</span>
                                    </div>
                                </a>
                                <a href="../../../main.html#/Store" style="text-decoration:none"
                                    (click)="actionMenu(6);">
                                    <div class="subLi crmhvr " (click)="actionMenu(6);" *ngIf="b2bRights.webStore">
                                        <span style="margin-right:8px"><i
                                                class="zmdi zmdi-city-alt"></i></span><span>Your Store</span>
                                    </div>
                                </a>
                                <a href="../../../main.html#/Settings" style="text-decoration:none;display:none">
                                    <div class="subLi crmhvr " (click)="actionMenu(13);"
                                        *ngIf="settingRgt.isShowSetting">
                                        <span  style="margin-right:8px"><i
                                                class="zmdi zmdi-accounts-alt"></i></span><span>Team</span>
                                    </div>
                                </a>
                                <a href="../../../main.html#/Search" style="text-decoration:none" *ngIf="crmRights.ConnViewTypeID != 0 || crmRights.SplrViewTypeID != 0">
                                    <div class="subLi crmhvr" (click)="actionMenu(11);">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-search"></i></span><span>Search</span>
                                    </div>
                                </a>
                                <!-- Reports -->
                                <a href="../../../main.html#/Reports" style="text-decoration:none" *ngIf="isPremiumAgencyPaid && (fullMdlRights.leads || fullMdlRights.quote || fullMdlRights.orders || fullMdlRights.support || 
                                fullMdlRights.invoices || fullMdlRights.purchase || fullMdlRights.accounts || fullMdlRights.inventory || fullMdlRights.manufacturing || fullMdlRights.tasks)">
                                    <div class="subLi crmhvr" (click)="actionMenu(50);">
                                        <span style="margin-right:8px"><i
                                                class="fa fa-line-chart"></i></span><span>Reports</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </li>

                    <li style="min-height:65px; background: #fff; display: none;">
                        <div class="bgwhite" style="min-height:65px; ">
                            <div style="padding-left:5%; padding-right:5%" (click)="showSubSource()">
                                <h3 style="color:#4caf50;font-size:15px; margin-top:12px ">
                                    <span style="font-weight:bold">Sourcing</span>
                                    <span class="chevron">
                                        <i class="zmdi {{subSourcing ?  '' : 'zmdi-chevron-down'}}"></i>
                                    </span>
                                </h3>
                                <h6 style="color:#4caf50; line-height:1.5"><span>Buy Right</span></h6>
                            </div>
                            <div *ngIf="selectedMenu.val == 4" style="padding-bottom: 10px;">
                                <!--ng-if="subSourcing"-->
                                <!--<div class="subLi sourcing" style="padding: 3px 6% !important" ng-click="actionMenu(19);">
                                <span style="color:#4caf50;margin-right:8px"><i class="zmdi zmdi-store"></i></span><span>Vendors</span>
                            </div>-->
                                <a href="../../../main.html#/Search" style="text-decoration:none">
                                    <div class="subLi sourcing" (click)="actionMenu(11);">
                                        <span style="color:#4caf50;margin-right:8px"><i
                                                class="fa fa-search"></i></span><span>Search</span>
                                    </div>
                                </a>
                                <a href="../../../main.html#/Purchase" style="text-decoration:none">
                                    <div class="subLi sourcing" (click)="actionMenu(15);"
                                        *ngIf="isShowInMenu.isPurchaseShow">
                                        <span style="color:#4caf50;margin-right:8px"><i
                                                class="fa fa-shopping-cart"></i></span><span>Orders</span>
                                    </div>
                                </a>
                                <a href="../../../main.html#/Purchase" style="text-decoration:none">
                                    <div class="subLi sourcing" (click)="actionMenu(15);"
                                        *ngIf="isShowInMenu.isPurchaseShow">
                                        <span style="color:#4caf50;margin-right:8px"><i
                                                class="fa fa-comments"></i></span><span>RFQs</span>
                                    </div>
                                </a>
                                <!--<div class="subLi sourcing" style="padding:3px 6% !important" ng-click="actionMenu(25);">
                                <span style="color:#4caf50;margin-right:8px"><i class="zmdi zmdi-account-circle"></i></span><span>Introductions</span>
                            </div>-->
                            </div>
                        </div>
                    </li>

                    <!-- <div class="textGreen bgwhite" (click)="openHelp();" style="padding: 0px 7px; font-size: 13px;">
                        Need help? -->
                    <!-- <a href="https://wa.me/918469966996" class="needHelp" target="_blank" style="color:inherit; display:block; font-size: 13px;">
                        Need help?
                    </a> -->
                    <!-- </div> -->


                    <!--Premium + Free-->
                    <li style="text-align: center;display:none">
                        <div style="padding: {{isPremium ? '0px' : '5px 10px 10px;'}}">
                            <!--Free-->
                            <span class="redText" style="font-size: 16px; font-weight: bold; cursor: pointer"
                                (click)="openSubMdl()" *ngIf="isFree && !isPremium">
                                <i class="zmdi zmdi-badge-check redText" style="font-size: 16px;"></i>
                                Upgrade
                            </span>
                            <!--Trial-->
                            <span class="redText" style="font-size: 16px; font-weight: bold; cursor: pointer"
                                (click)="openSubMdl()" *ngIf="!isPremium && !isFree"
                                title="{{agencyData.PremiumTillDT | date: 'dd-MMM-yy'}}">
                                <i class="zmdi zmdi-badge-check redText" style="font-size: 16px;"></i>
                                Upgrade <span *ngIf="daysToLeftTrial < 8 && daysToLeftTrial != 0"
                                    style="cursor: pointer;">({{daysToLeftTrial}} {{daysToLeftTrial == 1 ? 'day' :
                                    'days'}} left)</span>
                            </span>
                            <!--Premium-->
                            <!--<span class="yellowText" style="font-size: 16px; cursor:default; font-weight: bold;" ng-if="isPremium" title="{{agencyData.PremiumTillDT | date: 'dd-MMM-yy'}}">-->
                            <!--<span style="display: inline-block; background-image: url(../../images/crown.png); width: 20px; height: 14px; background-position: center; background-size: cover; margin-right: 3px; cursor: default"></span>-->
                            <!--Premium User <span ng-if="daysToLeftTrial < 8 && daysToLeftTrial != 0">({{daysToLeftTrial}} {{daysToLeftTrial == 1 ? 'day' : 'days'}} left)</span>-->
                            <!--</span>-->
                        </div>
                    </li>
                </ul>
                <!-- Store Page Then show Bewlow Menu -->
                <ul class="menu store" id="RespMenu"
                    style="background-color: rgb(154 154 154 / 10%); box-shadow: 1px 1px 4px 0px rgb(0 0 0 / 10%);"
                    *ngIf="isStorePage">

                    <li class="txtAlgnCenter storeMenuIcon stallBtn" style="top: 300px; width: 60px !important;"
                        title="Back" (click)="returnToExpo()">
                        <div class="iconTtl orangeText storeMenu" style="background-color: #e8842126;">
                            <span><i class="fa fa-arrow-left"></i></span>
                        </div>
                    </li>

                    <li class="txtAlgnCenter" style="top: 300px; width: 60px !important;" title="Home">
                        <div class="iconTtl greenText storeMenu" style="background-color: #4caf5026;"
                            (click)="actionMenu(0);">
                            <span><i class="fa fa-home"></i></span>
                        </div>
                    </li>
                    <!--Directory-->
                    <li class="txtAlgnCenter" style="top: 100px; width: 60px !important;" title="B2B Network"
                        (click)="actionMenu(7);" *ngIf="isShowInMenu.isB2BNetShow">
                        <div class="iconTtl tealText storeMenu" style="background-color: #00808026;">
                            <span style="position:relative;top:1px;"><i class="fa fa-globe"
                                    style="font-size:16px;"></i></span>
                        </div>
                    </li>

                    <!--Orders-->
                    <li class="txtAlgnCenter" style="top: 200px; width: 60px !important;" title="Orders"
                        *ngIf="isShowInMenu.isOrdersShow">
                        <div class="iconTtl blueText storeMenu" style="background-color: #1f628e26;"
                            (click)="actionMenu(1);">
                            <span><i class="fa fa-shopping-cart"></i></span>
                        </div>
                    </li>

                    <!--Inquiries-->
                    <li class="txtAlgnCenter" style="top: 250px; width: 60px !important;" title="Inquiries"
                        *ngIf="isShowInMenu.isInquiryShow && agencyData.CntInquiries > 0">
                        <div class="iconTtl brownText storeMenu" style="background-color: #79554826;"
                            (click)="actionMenu(2);">
                            <span><i class="fa fa-comments"></i></span>
                        </div>
                    </li>

                    <!--Purchases-->
                    <li class="txtAlgnCenter" style="top: 300px; width: 60px !important;" title="Purchases"
                        *ngIf="isShowInMenu.isPurchaseShow">
                        <div class="iconTtl tillText storeMenu" style="background-color: #1f628e26;"
                            (click)="actionMenu(15);">
                            <span><i class="fa fa-credit-card"></i></span>
                        </div>
                    </li>


                    <!--Receivables-->
                    <li class="txtAlgnCenter" style="top: 350px; width: 60px !important;" title="Recovery"
                        *ngIf="isShowInMenu.isRecoveryShow">
                        <div class="iconTtl orangeText storeMenu" style="background-color: #e8842126;"
                            (click)="actionMenu(5);">
                            <span style="position:relative;top:1px;"><i class="fa fa-rupee"></i></span>
                        </div>
                    </li>

                    <!--News Feed-->
                    <!--<li style="top: 50px; width: 80px !important;" title="Newsfeed">
                        <div class="iconTtl yellowText storeMenu" style="background-color: #E1A73026;" ng-click="actionMenu(9);">
                            <span><i class="fa fa-rss"></i></span>
                        </div>
                    </li>-->
                    <!--Search ng-click="actionMenu(10);"-->
                    <li class="txtAlgnCenter" style="top: 50px; width: 60px !important;" title="Search">
                        <div class="iconTtl greenText storeMenu" style="background-color: #4caf5026;"
                            (click)="actionMenu(11)">
                            <span><i class="fa fa-search"></i></span>
                        </div>
                    </li>

                    <li style="top: 300px; width: 60px !important;" title="Support"
                        *ngIf="isShowSupport && isShowInMenu.isSprtReqShow">
                        <div class="iconTtl tealText storeMenu" style="background-color: #00808026;"
                            (click)="actionMenu(16);">
                            <span><i class="fa fa-ticket"></i></span>
                        </div>
                    </li>

                    <li class="txtAlgnCenter" style="top: 50px; width: 60px !important; display: none;" title="Newsfeed"
                        *ngIf="isShowInMenu.isNewsFeedShow">
                        <div class="iconTtl yellowText storeMenu" style="background-color: #E1A73026;"
                            (click)="actionMenu(0);">
                            <span><i class="fa fa-home"></i></span>
                        </div>
                    </li>
                    <!--Promotion ng-click="actionMenu(12);"-->
                    <!--<li style="top: 200px; cursor: not-allowed; width: 80px !important;" title="Promotion">
                        <div class="iconTtl tealText storeMenu" style="background-color: #00808026;">
                            <span><i class="fa fa-bullhorn"></i></span>
                        </div>
                    </li>-->
                    <!--<li style="top: 300px; width: 80px !important;" title="Refresh">
                    <div class="iconTtl orangeText storeMenu menubottomBtn" ng-click="refresh();">
                        <span><i class="fa fa-refresh"></i></span>
                    </div>
                </li>

                <li style="top: 300px; width: 80px !important;" title="Logout">
                    <div class="iconTtl orangeText storeMenu menubottomBtn" ng-click="logOut();">
                        <span><i class="fa fa-power-off"></i></span>
                    </div>
                </li>

                <li style="top: 300px; width: 80px !important;" title="Appointments" ng-click="actionMenu(8);" ng-if="!agencyData.isAssociation && isShowInMenu.isAppShow">
                    <div class="iconTtl orangeText storeMenu menubottomBtn">
                        <span><i class="fa fa-calendar"></i></span>
                    </div>
                </li>

                <li style="top: 300px; width: 80px !important;" title="Settings" ng-click="actionMenu(13);" ng-if="settingRgt.isShowSetting">
                    <div class="iconTtl orangeText storeMenu menubottomBtn">
                        <span><i class="fa fa-cog"></i></span>
                    </div>
                </li>-->
                </ul>
            </div>

            <!-- Internation Web Menu -->
            <div class="row webView" style="margin: 0px;" *ngIf="!isIndianAgency">
                <div style="display: inline-block; ">
           <ul class="menu notStore animationIf" id="RespMenu" style="background-color: #fff; box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.1);
            text-align: left; padding: 0px 6px;" ng-show="!isStorePage">
            <!-- Biziverse Logo -->
            <li style="cursor: pointer;">
                <a href="https://www.biziverse.com" target="_blank">
                    <div class="" [ngStyle]="isQikERP ? {'padding': '5px 0px', 'text-align': 'left'} : {'padding': '15px 0px', 'text-align': 'left'}">
                        <img [src]="isQikERP ? 'assets/images/QikERP.png' : 'assets/images/logo2.jpg'" style="width: 100px;" alt="Biziverse" />
                    </div>
                </a>
            </li>
            <li>
                <div style="padding: 5px 0px 12px 2px; margin-right: 35px;">
                    <!-- <span class=""
                        style="border-radius: 50%; vertical-align: middle; margin: 0px 0px; padding: 0px !important">
                        <span class="btn menubottomBtn " style="border-radius: 50%" title="Dashboard"
                            (click)="actionMenu(0);">
                            <i class="fa fa-home" style="display: inline-block;"></i>
                        </span>
                    </span> -->
                    <span class=""
                        style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px;  padding: 0px !important">
                        <span class="btn menubottomBtn" style="border-radius: 50%;padding: 1px 8px!important;" title="Need help?"
                            (click)="openHelp();">
                            <i class="fa fa-question" style="display: inline-block;"></i>
                        </span>
                    </span>
                    <span class=""
                        style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                        <span class="btn menubottomBtn " style="border-radius: 50% " title="Refresh"
                            (click)="RefreshPage();">
                            <i class="fa fa-refresh" style="display: inline-block"></i>
                        </span>
                    </span>
                    <!-- Change Pin -->
                    <span *ngIf="!settingRgt.isShowSetting" class=""
                        style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important;">
                        <span class="btn menubottomBtn " style="border-radius: 50% " title="Change Password" ng-click="changePassword();">
                            <i class="fa fa-key" style="display: inline-block;"></i>
                        </span>
                    </span>

                    <span class=""
                        style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                        <span class="btn menubottomBtn " style="border-radius: 50% " title="Settings"
                            (click)="actionMenu(13);" *ngIf="settingRgt.isShowSetting">
                            <i class="fa fa-cog" style="display: inline-block;"></i>
                        </span>
                    </span>
                    <span class=""
                        style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                        <span class="btn menubottomBtn " style="border-radius: 50% " title="Logout"
                            (click)="logOut();">
                            <i class="fa fa-power-off" style="display: inline-block;"></i>
                        </span>
                    </span>
                </div>
            </li>

            <!--Premium + Free-->
            <li style="display: none;">
                <div style="padding: {{isPremium ? '0px' : '5px 10px 10px;'}}; text-align: left;">
                    <!--Free-->
                    <span class="redText" style="font-size: 16px; font-weight: bold; cursor: pointer" ng-click="openSubMdl()" ng-if="agencyData.isExpired">
                        <!--isFree && !isPremium-->
                        <i class="zmdi zmdi-badge-check redText" style="font-size: 16px;"></i>
                        Upgrade
                    </span>
                    <!--Trial-->
                    <span class="redText" style="font-size: 16px; font-weight: bold; cursor: pointer" ng-click="openSubMdl()" ng-if="!isPremium && !agencyData.isExpired" title="{{agencyData.PremiumTillDT | date: 'dd-MMM-yy'}}">
                        <i class="zmdi zmdi-badge-check redText" style="font-size: 16px;"></i>
                        Upgrade <span ng-if="daysToLeftTrial < 8 && daysToLeftTrial != 0" style="cursor: pointer;">({{daysToLeftTrial}} {{daysToLeftTrial == 1 ? 'day' : 'days'}} left)</span>
                    </span>
                </div>
            </li>

            <!-- CRM = Prospects -->
            <li style="min-height: 70px; background: #fff;" *ngIf="crmRights.propViewTypeID != 0 || crmRights.propEntry || crmRights.propEdit">
                <div style="min-height: 40px; padding: 0px 10px 10px; ">
                    <a style="padding-left: 5%; padding-right: 5%" href="{{isPremiumAgency ? '../../../main.html#/Kanban' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(21)">
                        <div>
                            <h3 style="color: #E88421; font-size: 16px; margin-top: 20px;text-align:left;">
                                <span>
                                    <i class="zmdi zmdi-account-add" style="margin-right: 5px;"></i>CRM 
                                </span>
                                <!-- </span> -->
                            </h3>
                            <h6 style="color: #888; line-height: 1.5; text-align:left;"><span> Monitor Prospects at each Stage till Conversion </span></h6> <!--'Delight Customers, Expand Bussiness'-->
                        </div>
                    </a>
                </div>
            </li>

            <!-- Orders -->
            <li style="min-height:70px;background:#fff;" *ngIf="crmRights.ordViewTypeID == 1 || crmRights.ordeEntry || crmRights.ordChange || crmRights.ordStatusChng">
                <div style="min-height: 40px; padding: 0px 10px 10px; ">
                        <a style="padding-left:5%; padding-right:5%" href="{{isPremiumAgency ? '../../../main.html#/orders' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                             (click)="actionMenu(1);">
                        <div >
                            <h3 style="color: #DAA520; font-size: 16px; margin-top: 12px;text-align:left;">
                                <span> <i class="fa fa-shopping-cart" style="margin-right: 5px;"></i>Orders </span>
                            </h3>
                            <h6 style="color: #888; line-height: 1.5; text-align:left;"><span>Ensure timely delivery of Sales & Services</span></h6> <!--'Delight Customers, Expand Bussiness'-->
                        </div>
                    </a>
                </div>
            </li>

            <!-- Inventory -->
            <li style="min-height:70px;background:#fff" *ngIf="agnERPRight.EnblInventory && (erpRights.invStatus || erpRights.invTran || erpRights.invEntry || erpRights.invRpt || erpRights.invCfg)">
                <div style="min-height: 40px; padding: 0px 10px 10px;">
                    <a style="padding-left:5%; padding-right:5%"  href="{{isPremiumAgency ? 'Stock' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none"
                        *ngIf="erpRights.invStatus || erpRights.invTran || erpRights.invEntry || erpRights.invRpt || erpRights.invCfg" (click)="actionMenu(27)">
                    <div class="">
                        <h3 style="color: #4caf50; font-size: 16px; margin-top: 12px; text-align:left;">
                            <span> <i class="zmdi zmdi-widgets" style="margin-right: 5px;"></i>Inventory </span>
                        </h3>
                        <h6 style="color: #888; line-height: 1.5; text-align:left;"><span>Manage Stock of Products & Materials</span></h6> <!--'Delight Customers, Expand Bussiness'-->
                      </div>
                    </a>
                </div>
            </li>

            <!-- Tasks -->
            <li style="min-height:70px;background:#fff;" *ngIf="agnERPRight.ETS">
                <div style="min-height: 40px; padding: 0px 10px 10px; ">
                        <a  style="padding-left: 5%; padding-right: 5%" href="Tasks" style="text-decoration:none;"
                        (click)="actionMenu(34);">
                        <div (click)="actionMenu(34);"
                            *ngIf="isShowInMenu.isPurchaseShow">
                        <h3 style="color: #008080; font-size: 16px; margin-top: 12px;text-align:left;">
                            <span >
                                <i class="fa fa-tasks" style="margin-right: 5px;"></i>Tasks
                            </span>
                        </h3>
                        <div>
                            <h6 style="color: #888; line-height: 1.5; text-align:left;"><span>Organize Team Tasks & Status updates </span></h6> <!--'Delight Customers, Expand Bussiness'-->
                        </div>
                        </div>
                    </a>
                </div>
            </li>

            <!-- Support -->
            <li style="min-height:70px;background:#fff" *ngIf="crmRights.ordViewTypeID == 1 || crmRights.ordeEntry || crmRights.ordChange || crmRights.ordStatusChng">
                <div style="min-height: 40px; padding: 0px 10px 10px;">
                        <a style="padding-left: 5%; padding-right: 5%" href="{{isPremiumAgency ? '../../../main.html#/orders?ID=sup' : '../../../main.html#/home?isUpMdl=1'}}" style="text-decoration:none" (click)="actionMenu(31)">
                            <div>
                          <h3 style="color: #1f628e; font-size: 16px; margin-top: 12px;text-align:left; ">
                            <span>
                                <i class="fa fa-headphones" style="margin-right: 5px;"></i>Support
                            </span>
                        </h3>
                        <h6 style="color :#888; line-height: 1.5; text-align:left;"><span>Delight Customers with prompt Ticket updates</span></h6> <!--'Delight Customers, Expand Bussiness'-->
                    </div>
                    </a>
                </div>
            </li>
        </ul>
    </div>
</div>

            <!-- Accounts only 150 -->
            <div class="row webView" style="margin: 0px;" *ngIf="isIndianAgency && (isVoucher || isStockEntry) && bzvzEdition == 4">
                <div style="display: inline-block; ">
                    <ul class="menu notStore animationIf" id="RespMenu" style="background-color: #fff; box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.1);
                        text-align: left; padding: 0px 6px;" *ngIf="!isStorePage">
                        <!-- Biziverse Logo -->
                        <li style="cursor: pointer; text-align: left;">
                            <a href="https://www.biziverse.com" target="_blank" style="text-align: left; display: inline-block; margin-right: 27px;">
                                <div class="" style="padding: 15px 0px; text-align: left;">
                                    <img src="assets/images/logo2.jpg" style="width: 100px;" alt="Biziverse" />
                                </div>
                            </a>
                        </li>
    
                        <!-- Icons -->
                        <li>
                            <div style="padding: 5px 0px 12px 2px;">
                                <span class=""
                                    style="border-radius: 50%; vertical-align: middle; margin: 0px 0px; padding: 0px !important">
                                    <span class="btn menubottomBtn " style="border-radius: 50%" title="Dashboard"
                                        (click)="actionMenu(0);">
                                        <i class="fa fa-home" style="display: inline-block;"></i>
                                    </span>
                                </span>
                                <span class=""
                                    style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px;  padding: 0px !important">
                                    <span class="btn menubottomBtn" style="border-radius: 50%;padding: 1px 8px!important;" title="Need help?"
                                        (click)="openHelp();">
                                        <i class="fa fa-question" style="display: inline-block;"></i>
                                    </span>
                                </span>
                                <span class=""
                                    style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                                    <span class="btn menubottomBtn " style="border-radius: 50% " title="Refresh"
                                        (click)="RefreshPage();">
                                        <i class="fa fa-refresh" style="display: inline-block"></i>
                                    </span>
                                </span>
                                <!-- Change Pin -->
                                <span *ngIf="!settingRgt.isShowSetting" class=""
                                    style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important;">
                                    <span class="btn menubottomBtn " style="border-radius: 50% " title="Change Password"  (click) ="changePassword();">
                                        <i class="fa fa-key" style="display: inline-block; font-size: 11px;"></i>
                                    </span>
                                </span>
                                <span class=""
                                    style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                                    <span class="btn menubottomBtn " style="border-radius: 50% " title="Settings"
                                        (click)="actionMenu(13);" *ngIf="settingRgt.isShowSetting">
                                        <i class="fa fa-cog" style="display: inline-block;"></i>
                                    </span>
                                </span>
                                <span class=""
                                    style="border-radius: 50%; vertical-align: middle;  margin: 0px 0px; padding: 0px !important">
                                    <span class="btn menubottomBtn " style="border-radius: 50% " title="Logout"
                                        (click)="logOut();">
                                        <i class="fa fa-power-off" style="display: inline-block;"></i>
                                    </span>
                                </span>
                            </div>
                        </li>
    
                        <!-- Accounts -->
                        <li style="min-height: 65px; background: #fff; text-align: left;" *ngIf="(bzvzEdition == 4 || ((agnERPRight.EnblAccounts) && erpRights.showERP))">
                            <div style="min-height: 65px;">
                                <div style="padding-left:5%; padding-right:5%">
                                    <h3 style="color:#e88421;font-size:20px ;margin-top:12px">
                                        <span style="font-weight:bold">Accounts</span>
                                    </h3>
                                </div>
                                <div style="padding-bottom:10px; transition:2s">
                                    <!-- 1 Balance Sheet -->
                                    <a href="{{isPremiumAgency ? 'balanceSheet' : '#'}}" style="text-decoration:none" *ngIf="erpRights.acctRpt">
                                        <div class="subLi accBalanceSheet col-md-12 dplblk" style="color: #DAA520; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-balance-scale headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Balance Sheet   
                                            </div>
                                        </div>
                                    </a>
    
                                    <!-- 2 Profit & Loss -->
                                    <a href="{{isPremiumAgency ? 'profitandLoss' : '#'}}" style="text-decoration:none" *ngIf="erpRights.acctRpt">
                                        <div class="subLi accProfiltLoss col-md-12 dplblk" style="color: #4caf50; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-line-chart headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Profit & Loss
                                            </div>
                                        </div>
                                    </a>
                                    <!-- 3 Trial Balance -->
                                    <a href="{{isPremiumAgency ? 'trialBalance' : '#'}}" style="text-decoration:none" *ngIf="erpRights.acctRpt">
                                        <div class="subLi accTrial col-md-12 dplblk" style="color: #008080; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-file headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Trial Balance
                                             </div>
                                        </div>
                                    </a>
                                    <!-- 4 Reconciliation -->
                                    <a href="{{isPremiumAgency ? 'Reconciliation' : '#'}}" style="text-decoration:none" *ngIf="erpRights.acctRpt">
                                        <div class="subLi accReconciliation col-md-12 dplblk" style="color:#1f628e; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-university" aria-hidden="true"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Reconciliation
                                            </div>
                                        </div>
                                    </a>
    
                                    <!-- 5 Stock Value -->
                                    <a href="{{isPremiumAgency ? 'dailyStock' : '#'}}" style="text-decoration:none" *ngIf="erpRights.acctConfig">
                                        <div class="subLi accStockValue col-md-12 dplblk" style="color: #15304a; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="zmdi zmdi-widgets headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Stock Value
                                            </div>
                                        </div>
                                    </a>
                                    <!-- 6 Sales -->
                                    <a href="{{isPremiumAgency ? '../../../main.html#/Invoices' : '#'}}" style="text-decoration:none" (click)="actionMenu(24)" *ngIf="crmRights.invoiceView">
                                        <div class="subLi accSales col-md-12 dplblk" style="color: #795548; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-money headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Sales
                                            </div>
                                        </div>
                                    </a>
    
                                    <!-- 7 Purchases -->
                                    <a href="{{isPremiumAgency ? '../../../main.html#/Docs?M=8' : '#'}}" style="text-decoration:none" *ngIf="crmRights.invoiceView">
                                        <div class="subLi accPurchases col-md-12 dplblk" style="color: #E88421; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-file-text-o headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Purchases
                                            </div>
                                        </div>
                                    </a>
    
                                    <!-- 8 Credit Notes -->
                                    <a href="{{isPremiumAgency ? '../../../main.html#/Docs?M=4' : '#'}}" style="text-decoration:none" *ngIf="crmRights.invoiceView">
                                        <div class="subLi accCreditNotes col-md-12 dplblk" style="color: #DAA520; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="zmdi zmdi-balance-wallet headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Credit Notes
                                            </div>
                                        </div>
                                    </a>
    
                                    <!-- 9 Debit Notes -->
                                    <a href="{{isPremiumAgency ? '../../../main.html#/Docs?M=5' : '#'}}" style="text-decoration:none" *ngIf="crmRights.invoiceView">
                                        <div class="subLi accDebitNotes col-md-12 dplblk" style="color: #4caf50; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%; text-align: end; transform: rotate(180deg);"><i class="zmdi zmdi-balance-wallet headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Debit Notes
                                            </div>
                                        </div>
                                    </a>
    
                                    <!-- 10 Recovery -->
                                    <a href="{{isPremiumAgency ? '../../../main.html#/Network?st=R' : '#'}}" style="text-decoration:none" *ngIf="crmRights.invRecovery">
                                        <div class="subLi accRecovery col-md-12 dplblk" (click)="actionMenu(5);" style="color: #008080; padding: 10px 6% !important;">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-inr headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Recovery
                                            </div>
                                        </div>
                                    </a>
                                    <!-- 11 Connections -->
                                    <a href="{{isPremiumAgency ? '../../../main.html#/Network?st=c' : '#'}}" style="text-decoration:none" *ngIf="b2bRights.conn">
                                        <div class="subLi accConnections col-md-12 dplblk" style="color: #1f628e; padding: 10px 6% !important;" (click)="actionMenu(7);">
                                            <div class="dplblk" style="width: 13%"><i class="fa fa-globe headerIcon"></i></div>
                                            <div class="dplblk" style="width: 80%">
                                                Connections
                                            </div>
                                        </div>
                                    </a>
    
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!--Right + Body-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding-left: {{(isVoucher || isStockEntry) && !isClosSettingShow ? '115px' : '0px'}};padding-right: 0px; background-color: #f1f1f3;">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<!-- Suggest Profile Modal-->
<ng-template #suggestProfile let-modal>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
      <app-suggest-profile></app-suggest-profile>
    </div>
</ng-template>
